(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipMatchesPublic
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('ChampionshipMatchesPublic', ChampionshipMatchesPublic);

  function ChampionshipMatchesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/matches', {id: '@_id'});
  }
}());
